import React, { createContext, useContext, useState } from 'react';

const AppSettingsContext = createContext();

export const AppSettingsProvider = ({ children }) => {
  const [appSettings, setAppSettings] = useState({});

  return (
    <AppSettingsContext.Provider value={{ appSettings, setAppSettings }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => useContext(AppSettingsContext);

export const useSetting = (key, fallback = null) => {
  const { appSettings } = useAppSettings();

  const rawSetting = appSettings?.[key];
  if (!rawSetting) return fallback;

  const { value, type } = rawSetting;

  // Fallback for missing or bad type values
  const settingType = type || (value === 'true' || value === 'false' ? 'checkbox' : 'text');

  switch (settingType) {
    case 'checkbox':
      return value === 'true';
    case 'number':
      return Number(value);
    case 'json':
      try {
        return JSON.parse(value);
      } catch {
        return fallback;
      }
    default:
      return value;
  }
};

export const useSettings = useSetting;
